import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) {
      navigate("/");
      return;
    }
    (async () => {
      try {
        await api.post("/auth/session", { session_id });
        await refresh();
        // strip hash
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        navigate("/");
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-[60vh] grid place-items-center text-white/60 font-mono">
      <div className="text-sm uppercase tracking-[0.3em]">Authenticating…</div>
    </div>
  );
}
